<template>
  <div class="md:py-8 md:w-80">
    <div class="mx-auto max-w-rxl sm:px-6 lg:px-8">
      <div class="overflow-hidjen bg-white shadow-xl p-7 sp:p-3 border-solid border border-gray-200">
        <div class="w-full text-right">
          <template v-if="questionListMenu">
            <button
              v-if="onResize"
              class="bg-gray-500 lg:hover:bg-gray-300 active:bg-gray-300 duration-300 text-white py-3 px-4 text-xs my-1 rounded-lg"
              @click="onClickedQuestionListMenu">
              <p class="flex items-center">
                解答リスト
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                    clip-rule="evenodd" />
                </svg>
              </p>
            </button>
          </template>
        </div>
        <div class="bg-gray-100 rounded-lg border-2 border-gray-500">
          <div
            id="question-list"
            class="overflow-auto h-56 md:h-96 pt-3">
            <ul
              v-if="props.allQuestions"
              id="list"
              class="px-2">
              <template
                v-for="(question, index) in props.allQuestions"
                :key="index">
                <li
                  :class="{ 'bg-white rounded-md pl-4 border-4 border-gray-300' : isCurrentAnsweredQuestion(question.id) }"
                  class="w-full text-base whitespace-nowrap mb-1 px-2 py-1 cursor-pointer box-border bg-white rounded-md pl-4 border-2"
                  @click="onClickedQuestionLink(index)">
                  <div class="flex">
                    <svg
                      v-if="isAnsweredQuestion(question.id)"
                      xmlns="http://www.w3.org/2000/svg"
                      class="mr-2 h-6 w-6 text-green-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p>{{ `${index+1}問目` }}</p>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <button
          class="bg-red-500 lg:hover:bg-red-300 active:bg-red-300 duration-300 text-white py-2.5 px-6 sp:py-3 sp:px-4 sp:text-sm mt-3 rounded-lg"
          @click="$emit('confirmation')">
          試験を終了する
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineEmits, computed, reactive, onUpdated, watch, ref,
} from 'vue'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  answersArr: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: Number,
    default: 0,
  },
  questionIndex: {
    type: Number,
    default: 0,
  },
  countAnswer: {
    type: Number,
    default: 0,
  },
  questions: {
    type: Array,
    default: () => [],
  },
  isClickedQuestionList: {
    type: Boolean,
    default: false,
  },
  onResize: {
    type: Boolean,
    default: false,
  },
  questionListMenu: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['link-click', 'confirmation', 'on-clicked-question-list-menu', 'assign-index'])
const onClickedQuestionListMenu = () => {
  emit('on-clicked-question-list-menu')
}

const refColor = ref('black')
const isChangeColor = ref(false)
const setBgColor = () => {
  isChangeColor.value = !isChangeColor.value
  if (isChangeColor.value) {
    refColor.value = 'red'
  } else {
    refColor.value = 'black'
  }
}

const answersIdArr = ref([])
const answersId = computed(() => {
  if (props.answersArr) {
    props.answersArr.map(answer => answersIdArr.value.push(answer.question_id))
  }
  return answersIdArr.value
})
const duplicateQuestionIds = computed(() => props.questions.filter((id) => answersId.value.includes(id)))
const isAnsweredQuestion = (id) => duplicateQuestionIds.value.includes(id)

const isCurrentAnsweredQuestion = (id) => id === props.allQuestions[props.questionIndex].id

const onClickedQuestionLink = async (index) => {
  emit('assign-index', index)
  emit('link-click')
}

onUpdated(() => {
  if (!props.isClickedQuestionList) {
    const listDom = document.querySelector('#list')
    listDom.children[props.questionIndex].scrollIntoView(false)
  }
})
</script>
<style scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 50, .5);
  border-radius: 10px;
  box-shadow:0 0 0 1px rgba(255, 255, 255, .3);
}
</style>
